import React from 'react';
import { useSelector } from 'react-redux';
import EquipmentTemplate from '../../components/equiqtemplate/EquipmentTemplate';
import PlumberImg1 from '../../assest/Plumber-1.png';
import PlumberImg2 from '../../assest/plumber-2.png';
import PlumberImg3 from '../../assest/plumber-3.jpg';

const plumbersList = [
  {
    name: "Residential Plumber",
    image: PlumberImg1,
    specs: "Home plumbing installations and repairs.",
    description: "Experienced in handling leaks, pipe fitting, and sanitary systems in residential settings.",
  },
  {
    name: "Commercial Plumber",
    image: PlumberImg2,
    specs: "Large-scale plumbing for offices and buildings.",
    description: "Specialized in complex piping networks and maintenance for commercial properties.",
  },
  {
    name: "Emergency Plumber",
    image: PlumberImg3,
    specs: "24/7 on-call services for urgent issues.",
    description: "Ready to respond to burst pipes, clogs, and other urgent plumbing problems anytime.",
  },
];

const translations = {
  gb: {
    heading: "Plumber Services",
    introText: "Choose from our trusted plumber services tailored for homes, offices, and emergencies.",
    categoriesTitle: "Available Services",
    featuredTitle: "Top Plumbers",
    featuredDescription: "Certified plumbers available for any project, big or small.",
  },
  sa: {
    heading: "خدمات السباكة",
    introText: "اختر من بين خدمات السباكة الموثوقة لدينا للمنازل والمكاتب والطوارئ.",
    categoriesTitle: "الخدمات المتاحة",
    featuredTitle: "أفضل السباكين",
    featuredDescription: "سباكون معتمدون جاهزون لأي مشروع، كبير أو صغير.",
  },
};

const Plumbers = () => {
  const { language } = useSelector((state) => state.language);
  const t = translations[language] || translations.gb;

  return (
    <EquipmentTemplate
      content={t}
      equipmentList={plumbersList}
      language={language}
    />
  );
};

export default Plumbers;
